export const ORG_ID_PATTERN = /^[a-z0-9]{6}$/

export function isOrgIdShaped(text: string): boolean {
  return ORG_ID_PATTERN.test(text)
}
